export const enum GridStateTypeEnums {
    Column = 1,
    Pivot_Mode = 2,
    Column_Sort = 3,
    Column_Filter = 4,
    Column_Group = 5
  }